<div class="flex-column gap-32">
	<app-card preCardTitle="New Inspection Form">
		<div *appCardContent class="settings-header-container">
			<div class="settings-header-title">
				<p>Create new form</p>
				<div class="settings-header-subtitle">Use one of out templates or create one from scratch</div>
			</div>
			<div class="settings-header-actions">
				<button mat-stroked-button
						[matMenuTriggerFor]="newFormMenu">
					<div class="flex-row align-items-center">
						Create New Form
						<mat-icon class="mr--10">
							arrow_drop_down
						</mat-icon>
					</div>
				</button>
				<mat-menu #newFormMenu="matMenu">
					<button mat-menu-item
							(click)="buttonClickedNew()">
						From Scratch
					</button>
					<button mat-menu-item
							[matMenuTriggerFor]="templateFormMenu">
						From Template
					</button>
				</mat-menu>
				<mat-menu #templateFormMenu="matMenu">
					<button mat-menu-item *ngFor="let form of systemForms"
							(click)="buttonClickAddFromTemplate(form)">
						<span [ngClass]="{'bolder' : form.default}">{{form.form.title}}</span>
					</button>
				</mat-menu>
			</div>
		</div>
	</app-card>

	@if (loading) {
		<mat-spinner class="mx-a my-15" diameter="30"></mat-spinner>
	}
	@else {
		<app-card preCardTitle="Inspection Forms">
			<div *appCardContentRaw>
				<mat-nav-list class="raw-card-list">
					<mat-menu #menuInspectionForm="matMenu">
						<ng-template matMenuContent let-form="form">
							<button mat-menu-item [routerLink]="['/' + RootRoute.SETTINGS, SettingsRoute.INSPECTION_FORMS, form.id]">
								Open
							</button>
							<button mat-menu-item (click)="duplicateForm(form.id)">
								Duplicate
							</button>
							<button mat-menu-item
									(click)="deleteForm(form)">
								Remove
							</button>
						</ng-template>
					</mat-menu>
					@for (form of inspectionForms; track form.id) {
						<mat-list-item [routerLink]="['/' + RootRoute.SETTINGS, SettingsRoute.INSPECTION_FORMS, form.id]">
							<a matListItemTitle>{{ form.title }}</a>
							<div matListItemMeta>
								<button mat-icon-button
										(click)="$event.stopPropagation()"
										[matMenuTriggerFor]="menuInspectionForm"
										[matMenuTriggerData]="{form:form}"
										aria-label="Menu">
									<mat-icon>more_vert</mat-icon>
								</button>
							</div>
						</mat-list-item>
						@if (!$last) {
							<mat-divider></mat-divider>
						}
					}
				</mat-nav-list>
			</div>
		</app-card>
	}
</div>
